import { IPaymentMethodFormType } from "@nju/data-access-portal-payment";

export function mapPaymentMethod(
  paymentMethod: IPaymentMethodFormType | undefined,
) {
  if (paymentMethod === "CREDIT_CARD") {
    return "Card";
  }

  if (paymentMethod === "DIGITAL_WALLET") {
    return "BLIK";
  }

  if (paymentMethod === "PAY_BY_LINK") {
    return "Online";
  }

  return;
}
